import { render, staticRenderFns } from "./receiptTemplateList.vue?vue&type=template&id=cc98ad9e&scoped=true&"
import script from "./receiptTemplateList.vue?vue&type=script&lang=js&"
export * from "./receiptTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc98ad9e",
  null
  
)

component.options.__file = "receiptTemplateList.vue"
export default component.exports